<template>
    <card-tile title="Sessions" full-width :min-height="270">
        <div class="px-4 py-4 text-center" v-if="sessions.length == 0">
            <h3 class="grey--text text--darken-2">
                You are not assigned any sessions.
            </h3>
            <v-btn
                class="mt-4 mx-auto"
                large
                color="secondary darken-2"
                :to="{
                    name: 'Program Edit',
                    params: {
                        id: program.id,
                    },
                    query: {
                        scrollTo: 'program-sessions',
                        addsession: true,
                    },
                }"
            >
                <v-icon class="mr-2">{{ $config("icons.session") }}</v-icon>
                Add Sessions
            </v-btn>
        </div>

        <session-select
            v-if="sessions.length > 0"
            :sessions="sessions"
            @select-session="$emit('select-session', $event)"
            @update-selected="$emit('update:selected', $event)"
        ></session-select>
    </card-tile>
</template>

<script>
export default {
    name: "sessions-card",
    components: {
        CardTile: () =>
            import("@/components/program/components/Dashboard/CardTile.vue"),
        SessionSelect: () =>
            import("@/components/program/components/SessionSelect.vue"),
    },
    props: {
        program: {
            type: Object,
            required: true,
        },
        sessions: {
            type: Array,
            required: true,
        },
        selected: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>